<template>
  <el-main class="eco-table-panel sds" ref="tablePanel" id="feTable">
    <div class="toolbar-panel" ref="toolbarPanel">
      <el-row>
        <el-col :span="16" class="common-tools">
          <div style="text-align: left">
            <slot name="toolbar" style="float: left"></slot>
            <el-button v-if="showExport" size="small" type="text" @click="exports()"> 导出 </el-button>
          </div>
        </el-col>
        <el-col :span="8" class="search-container__col">
          <div style="width: 100%; display: flex; justify-content: end">
            <div style="display: flex; justify-content: end">
              <eco-input
                prefix-icon="el-icon-search"
                class="quick-search"
                v-if="quickSearchConfig && quickSearchConfig.length > 0"
                v-model.lazy="quickSearchWord"
                @keyup.enter.native="quickSearch"
                :placeholder="quickSearchPlaceholder"
                :autofocus="true"
                :disabled="loading || showAdvancedSearch"
                ref="quickSearch"
                :debounce="2000"
              >
              </eco-input>

              <div class="select-search-panel" ref="selectSearchPanel">
                <slot name="selectSearch"></slot>
              </div>
            </div>
            <el-button
              v-if="quickSearchConfig && quickSearchConfig.length > 0"
              :disabled="loading || showAdvancedSearch"
              @click="quickSearch"
              type="primary"
              size="mini"
              slot="reference"
              class="advanceBtn"
              >搜索</el-button
            >
            <el-popover
              placement="bottom"
              v-if="hasSearchPanel"
              popper-class="advancedPopover"
              :visible-arrow="!hasSearchPanel"
              v-model="showAdvancedSearch"
              trigger="click"
              @pophide="resetPopover"
              @advancesearch="advanceSearch"
            >
              <div ref="searchPanel">
                <slot name="search"></slot>
              </div>

              <el-button v-if="showAdvancedSearch === false" size="mini" slot="reference" class="advanceBtn2">高级搜索</el-button>
              <el-button v-else size="mini" slot="reference" class="advanceBtn2 bgWhite">高级搜索</el-button>
            </el-popover>
          </div>
        </el-col>
      </el-row>
    </div>
    <div ref="tabPanel">
      <fe-table-tab
        :tabList="tabList"
        :tabProp="tabProp"
        :activeName="activeName"
        :operation="operation"
        @tabchange="tabChange"
        v-if="tabList && tabList.length > 0"
      ></fe-table-tab>
    </div>
    <div ref="tabPanel2">
      <fe-table-tab2
        v-if="tabList2 && tabList2.length > 0"
        :tabList="tabList2"
        :tabProp="tabProp2"
        :activeName="activeName2"
        :operation="operation"
        @tabchange2="tabChange2"
      ></fe-table-tab2>
    </div>
    <el-table
      :style="{ height: `${tableMaxHeight}` + 'px' }"
      :data="data"
      :cell-style="cellStyle"
      :header-cell-style="headerCellStyle"
      v-loading="loading"
      ref="ecoTable"
      border
      :show-header="showHeader"
      :max-height="tableMaxHeight"
      :default-querys="defaultQuerys"
      :highlight-current-row="highlightCurrentRow"
      @row-click="handleRowClick"
      @select="handleTableSelect"
      @select-all="handleTableSelect"
      @sort-change="handleSortChange"
      @filter-change="handleFilterChange"
      class="eco-table"
      size="mini"
    >
      <el-table-column type="selection" align="center" width="45" v-if="this.selectable" />
      <slot></slot>
    </el-table>
    <div v-if="!nopagination" class="pagination-panel" ref="paginationPanel">
      <el-row type="flex" justify="end">
        <el-pagination
          small
          :disabled="loading"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.page"
          :page-sizes="pageSizes"
          :page-size="pagination.pageSize"
          :pager-count="11"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        ></el-pagination>
      </el-row>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="自定义列表项"
      :visible.sync="customColumnDialogVisible"
      :before-close="customColumnDialogCancel"
      width="700px"
      append-to-body
    >
      <eco-checkbox v-model="currentCustomColumns" :options="customColumns" />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="customColumnDialogSure">确 定</el-button>
        <el-button size="small" @click="customColumnDialogCancel">取 消</el-button>
      </span>
    </el-dialog>

    <!--导出-->
    <el-dialog :close-on-click-modal="false" title="导出设置" :visible.sync="dialogExportVisible" width="50%" id="exportDialogs" :before-close="exportCancel">
      <el-form :model="exportData" status-icon="" ref="exportData" label-width="100px">
        <el-row type="flex" class="row-bg" justify="start" style="height: 48px; border: 1px solid #eee; text-align: center">
          <el-col :span="6" style="padding: 15px 0px 0px 15px"> 导出类型 </el-col>
          <el-col :span="18" style="border-left: 1px solid #eee; padding: 15px 0px 0px 15px">
            <el-switch v-model="exportData.getType" active-text="全部数据" active-value="all" inactive-text="当前页数据" inactive-value="page"> </el-switch>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg" justify="start" style="border: 1px solid #eee; text-align: center">
          <el-col :span="6" style="padding: 15px 0px 0px 15px"> 导出字段 </el-col>
          <el-col :span="18" style="border-left: 1px solid #eee; padding: 5px 0px 0px 5px; max-height: 420px; overflow: auto">
            <el-table
              ref="multipleExportTable"
              :data="exportDisplayFields"
              style="width: 100%"
              @select-all="handleExportSelectAll"
              tooltip-effect="dark"
              @selection-change="handleExportSelectionChange"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column prop="name" label="字段名称" width="200"> </el-table-column>
              <el-table-column prop="desc" label="字段描述" width="250"> </el-table-column>
              <el-table-column label="操作" width="160">
                <template slot-scope="scope">
                  <el-button @click="sort(scope.$index, 'down')" size="small" icon="el-icon-arrow-down" plain=""></el-button>
                  <el-button @click="sort(scope.$index, 'up')" size="small" icon="el-icon-arrow-up" plain=""></el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitExport()" size="small"> 确 定 </el-button>
        <el-button @click="exportCancel()" size="small"> 取 消 </el-button>
      </div>
    </el-dialog>
  </el-main>
</template>
<script>
import utils from '@/eco-ui-util.js'
import _ from 'lodash'
import { Base64 } from 'js-base64'
import { Loading } from 'element-ui'

export default {
  name: 'eco-table',
  props: {
    data: Array,
    showHeader: {
      type: Boolean,
      default: true
    },
    pageResult: {
      type: Object,
      default: () => {
        return { page: 1, pageSize: 50, total: 0 }
      }
    },
    pageSizes: {
      type: Array,
      default: () => {
        return [10, 20, 50, 100, 200, 300, 500]
      }
    },
    tabList: {
      type: Array,
      default: () => {
        return []
      }
    },

    tabList2: {
      type: Array,
      default: () => {
        return []
      }
    },
    nopagination: {
      type: Boolean,
      default: false
    },
    highlightCurrentRow: {
      type: Boolean,
      default: false
    },
    selectable: {
      type: Boolean,
      default: true
    },
    quickSearchProps: [String, Array],
    debounce: {
      type: Number,
      default: 1500
    },
    showExport: {
      type: Boolean,
      default: true
    },
    exportDisplayFields: {
      type: Array,
      default() {
        return []
      }
    },
    exportUrl: {
      type: String,
      default: ''
    },
    tabProp: {
      type: String,
      default: ''
    },
    tabProp2: {
      type: String,
      default: ''
    },
    exportFilename: {
      type: String,
      default: ''
    },

    activeName: {
      type: String,
      default: ''
    },
    activeName2: {
      type: [String, Boolean],
      default: ''
    },
    showCustomColumn: {
      type: Boolean,
      default: true
    },
    defaultQuerys: {
      type: Array,
      default() {
        return []
      }
    },
    exportQuerys: {
      type: Array,
      default() {
        return []
      }
    },
    defaultSorter: {
      type: Array,
      default() {
        return []
      }
    },
    operation: {
      type: String,
      default: () => {
        return 'EQUAL'
      }
    }
  },
  watch: {
    data: {
      handler(newVal) {
        this.$nextTick(() => {
          this.$refs.ecoTable.doLayout()
        })
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      querys: [],
      sorter: null,
      quickSearchWord: null,
      quickSearchPlaceholder: '请输入搜索内容',
      quickSearchConfig: null,
      hasSearchPanel: false,
      filters: {},
      activeNameChange: '',
      pagination: { ...this.pageResult },
      tableMaxHeight: document.body.clientHeight - 280,
      showAdvancedSearch: false,
      loading: false,
      columns: [],
      customColumns: [],
      customColumnsHashCode: null,
      currentCustomColumns: null,
      customColumnDialogVisible: false,
      selection: [],
      dialogExportVisible: false,
      exportData: { getType: 'all', expField: [] },
      exportSellection: []
    }
  },
  created() {
    // 从插槽中获取到当前表格的所有列
    this.$slots.default.forEach((n) => {
      const pd = n.componentOptions.propsData
      // 将当前表格的列放入一个数组
      this.columns.push(pd)
      // 将当前有有prop和label的列放入自定义列表项的数组中
      if (pd.prop && pd.label) {
        this.customColumns.push({
          key: pd.prop,
          value: pd.label,
          checked: !(pd.hidden === true || pd.hidden === '')
        })
      }
    })
    // 获取当前自定义列表项的hashCode
    this.customColumnsHashCode = utils.hashCode(JSON.stringify(this.customColumns))
    this.quickSearchProps && this.generateQuickSearchConfig()
  },
  computed: {
    calDefaultQuerys: function () {
      let calQuerys = []
      let query = {
        group: 'defaultQueryGroup',
        operation: 'EQUAL',
        relation: 'AND'
      }
      this.defaultQuerys.forEach((c) => {
        calQuerys.push({ ...query, ...c })
      })
      return calQuerys
    }
  },
  mounted() {
    this.debounceQuickSearch = _.debounce(() => {
      this.quickSearch()
    }, this.debounce)
    // 判断是否有高级搜索面板
    this.hasSearchPanel = !!this.$scopedSlots.search
    this.load()
    this.calcTableHeight()
    this.$watch('showAdvancedSearch', (n, o) => {
      if (n !== o) {
        if (n) {
          this.quickSearchWord = null
        }
        // 显示或收起搜索面板时，重新计算表格高度
        this.calcTableHeight(500)
      }
    })
    this.$watch('tabList', (n, o) => {
      if (n !== o) {
        this.calcTableHeight(500)
      }
    })
    this.$watch('tabList2', (n, o) => {
      if (n !== o) {
        this.calcTableHeight(500)
      }
    })
    this.$watch('pageResult', (n, o) => {
      if (n !== o) {
        this.pagination = { ...n }
      }
    })
    /**
             * 统一使用回车查询
             this.$watch("quickSearchWord", (n, o) => {
      if (n !== o) {
        this.debounceQuickSearch();
      }
    });
             */
    this.$root.$on('resize', () => {
      this.calcTableHeight(500)
      this.$nextTick(() => {
        this.$refs.ecoTable.doLayout()
      })
    })
    this.initialCustomColumn()
    this.$nextTick(() => {
      this.$refs.ecoTable.doLayout()
    })
  },
  methods: {
    headerCellStyle({ row, column, rowIndex, columnIndex }) {
      let str = column.label
      if (str && str != undefined) {
        if (
          str.indexOf('金额') > -1 ||
          str.indexOf('率') > -1 ||
          str.indexOf('成本') > -1 ||
          str.indexOf('盈亏') > -1 ||
          str.indexOf('产值') > -1 ||
          str.indexOf('余额') > -1 ||
          str.indexOf('日期') > -1 ||
          str.indexOf('到期日') > -1 ||
          str.indexOf('天') > -1 ||
          str.indexOf('时间') > -1 ||
          str.indexOf('元') > -1 ||
          str.indexOf('有效期') > -1 ||
          str.indexOf('年度') > -1 ||
          str.indexOf('项目总进度') > -1 ||
          str.indexOf('年龄') > -1 ||
          str.indexOf('号码') > -1 ||
          str.indexOf('联系方式') > -1 ||
          str.indexOf('运费') > -1 ||
          str.indexOf('数') > -1 ||
          str.indexOf('%') > -1 ||
          str.indexOf('利润') > -1 ||
          str.indexOf('产值所属期') > -1 ||
          str.indexOf('资金') > -1 ||
          str.indexOf('计划付款') > -1 ||
          str.indexOf('保证金') > -1 ||
          str.indexOf('管理费') > -1 ||
          str.indexOf('收款') > -1 ||
          str.indexOf('累计开票') > -1 ||
          str.indexOf('预缴税金') > -1 ||
          str.indexOf('税金总额') > -1 ||
          str.indexOf('所属期间') > -1 ||
          str.indexOf('核销借支') > -1 ||
          str.indexOf('税额') > -1 ||
          str.indexOf('累计已归还') > -1 ||
          str.indexOf('冲减备用金') > -1 ||
          str.indexOf('合计') > -1 ||
          str.indexOf('年月') > -1 ||
          str.indexOf('已支付') > -1 ||
          str.indexOf('应支付') > -1 ||
          str.indexOf('冲减备用金') > -1 ||
          (str.indexOf('已归还') > -1) | (str.indexOf('累计核量') > -1)
        ) {
          const obj = {
            textAlign: 'right',
            backgroundColor: '#F3F3F3',
            color: '#333'
          }
          return obj
        } else {
          const obj = {
            textAlign: 'left',
            backgroundColor: '#F3F3F3',
            color: '#333'
          }
          return obj
        }
      } else {
        const obj = {
          textAlign: 'center',
          backgroundColor: '#F3F3F3',
          color: '#333'
        }
        return obj
      }
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      let str = column.label
      if (str && str != undefined) {
        if (
          str.indexOf('金额') > -1 ||
          str.indexOf('率') > -1 ||
          str.indexOf('成本') > -1 ||
          str.indexOf('盈亏') > -1 ||
          str.indexOf('产值') > -1 ||
          str.indexOf('余额') > -1 ||
          str.indexOf('日期') > -1 ||
          str.indexOf('到期日') > -1 ||
          str.indexOf('天') > -1 ||
          str.indexOf('时间') > -1 ||
          str.indexOf('元') > -1 ||
          str.indexOf('有效期') > -1 ||
          str.indexOf('年度') > -1 ||
          str.indexOf('项目总进度') > -1 ||
          str.indexOf('年龄') > -1 ||
          str.indexOf('号码') > -1 ||
          str.indexOf('联系方式') > -1 ||
          str.indexOf('运费') > -1 ||
          str.indexOf('数') > -1 ||
          str.indexOf('%') > -1 ||
          str.indexOf('利润') > -1 ||
          str.indexOf('产值所属期') > -1 ||
          str.indexOf('资金') > -1 ||
          str.indexOf('计划付款') > -1 ||
          str.indexOf('保证金') > -1 ||
          str.indexOf('管理费') > -1 ||
          str.indexOf('收款') > -1 ||
          str.indexOf('累计开票') > -1 ||
          str.indexOf('预缴税金') > -1 ||
          str.indexOf('税金总额') > -1 ||
          str.indexOf('所属期间') > -1 ||
          str.indexOf('核销借支') > -1 ||
          str.indexOf('冲减备用金') > -1 ||
          str.indexOf('税额') > -1 ||
          str.indexOf('累计已归还') > -1 ||
          str.indexOf('合计') > -1 ||
          str.indexOf('年月') > -1 ||
          str.indexOf('已支付') > -1 ||
          str.indexOf('应支付') > -1 ||
          str.indexOf('冲减备用金') > -1 ||
          str.indexOf('已归还') > -1 ||
          str.indexOf('累计核量') > -1
        ) {
          return 'text-align:right'
        } else {
          return 'text-align:left'
        }
      } else {
        return 'text-align:center'
      }
    },
    resetPopover() {
      this.showAdvancedSearch = false
    },
    quickSearch() {
      // 先删除快速查询的查询条件
      this.clearQueryByGroupName('quick')
      this.clearQueryByGroupName('advance')
      this.quickSearchWord &&
        this.quickSearchConfig.forEach((c) => {
          let query = {
            property: c.prop,
            value: this.quickSearchWord.trim(),
            group: 'quick',
            relation: 'OR',
            operation: 'LIKE'
          }
          this.querys.push(query)
        })
      if (this.tabList && this.tabList.length > 0) {
        const query1 = {
          property: this.tabProp,
          value: this.activeNameChange,
          group: 'advance',
          relation: 'AND',
          operation: 'EQUAL'
        }
        if (this.activeNameChange && this.activeNameChange !== 'total') {
          this.querys.push(query1)
        }
      }
      this.load()
    },
    advanceSearch(data, reset) {
      if (this.loading || !this.showAdvancedSearch) {
        return
      }
      this.clearQueryByGroupName('quick')
      this.clearQueryByGroupName('advance')
      data &&
        data.forEach((d) => {
          let query = {}
          query = {
            property: d.prop,
            value: d.value,
            group: 'advance',
            relation: d.relation,
            operation: d.operation
          }
          query.value && this.querys.push(query)
        })
      if (!reset) {
        this.showAdvancedSearch = false
      }
      this.load()
    },
    tabChange(data) {
      this.sorter = null
      this.quickSearchWord = null
      this.clearQueryByGroupName('quick')
      this.clearQueryByGroupName('advance')
      this.activeName = data.value
      this.activeNameChange = data.value
      if (this.querys && this.querys.length > 0) {
        const _this = this
        _this.querys.forEach((ele, index) => {
          if (ele.property === _this.tabProp) {
            _this.querys.splice(index, 1)
          }
        })
      }
      if (data.value !== 'total') {
        this.querys.push(data)
      }
      this.$emit('gettab', data.value)

      this.load()
    },
    tabChange2(data) {
      this.sorter = null
      this.clearQueryByGroupName('quick')
      this.clearQueryByGroupName('advance')
      this.calcTableHeight(500)

      this.$emit('gettab', data)

      this.load(null, data)
    },
    // 加载数据
    load(doNotResetPage, activeName) {
      this.loading = true
      // 默认重置页码为第一页
      if (!doNotResetPage) {
        this.pagination.page = 1
      }
      let param = {
        pageBean: this.pagination
      }

      if (this.sorter && this.sorter.length > 0) {
        param.sorter = this.sorter
      }
      // 处理排序字段
      if (this.defaultSorter.length > 0) {
        if (!param.sorter) {
          param.sorter = []
        }
        this.defaultSorter.forEach((item) => {
          param.sorter.remove(item)
        })
        param.sorter = param.sorter.concat(this.defaultSorter)
      }
      // 处理过滤条件
      this.handleFilters()

      if (this.querys && this.querys.length > 0) {
        param.querys = this.querys
      }

      // 处理查询条件
      if (this.calDefaultQuerys.length > 0) {
        if (!param.querys) {
          param.querys = []
        }
        this.calDefaultQuerys.forEach((item) => {
          param.querys.remove(item)
        })
        param.querys = param.querys.concat(this.calDefaultQuerys)
      }

      const me = this
      // 防止外部没有回调，设置10秒后自动取消加载中的状态
      const finalTickCB = setTimeout(function () {
        me.loading = false
      }, 10000)

      if (this.nopagination) {
        param.pageBean = {}
      }
      this.$emit(
        'load',
        { ...param },
        () => {
          // 外部已经回调的情况下，取消倒计时
          clearTimeout(finalTickCB)
          me.loading = false
          setTimeout(() => {
            me.$refs.quickSearch && me.$refs.quickSearch.$children[0].$el.children[0].focus()
          })
        },
        activeName
      )

      this.$nextTick(() => {
        this.$refs.ecoTable.doLayout()
        this.calcTableHeight(500)
      })
    },
    // 通过列属性获取列标签
    getColumnLabelByProp(prop) {
      let label = null
      if (!prop) {
        return label
      }
      this.columns.forEach((c) => {
        if (c.prop && c.prop === prop) {
          label = c.label
        }
      })
      return label
    },
    // 构建快速搜索配置项
    generateQuickSearchConfig() {
      let labelAry = []
      if (typeof this.quickSearchProps == 'string') {
        const props = utils.stringSplit(this.quickSearchProps, ',')
        this.quickSearchConfig = []
        props.forEach((prop) => {
          const label = this.getColumnLabelByProp(prop)
          if (label) {
            labelAry.push(label)
            this.quickSearchConfig.push({ prop, label })
          }
        })
      }
      if (typeof this.quickSearchProps == 'object') {
        this.quickSearchProps.forEach((prop) => {
          if (prop && prop.label) {
            labelAry.push(prop.label)
          }
        })
        this.quickSearchConfig = [...this.quickSearchProps]
      }
      this.quickSearchPlaceholder = `请输入${labelAry.join(',')}来搜索`
    },
    // 通过分组名称清除对应查询条件
    clearQueryByGroupName(groupName) {
      // 待删除的查询条件
      let toDelete = []
      this.querys &&
        this.querys.forEach((query) => {
          if (query.group == groupName) {
            toDelete.push(query)
          }
        })
      toDelete.forEach((d) => {
        this.querys.remove(d)
      })
    },
    handleFilters() {
      this.clearQueryByGroupName('filter')
      // 将过滤条件添加查询参数数组中
      if (this.filters && Object.keys(this.filters).length > 0) {
        Object.keys(this.filters).forEach((k) => {
          const filter = this.filters[k]
          let query = {
            property: k,
            value: filter[0],
            group: 'filter',
            relation: 'AND'
          }
          if (filter.length == 1) {
            query.operation = 'EQUAL'
            this.querys.push(query)
          } else if (filter.length > 1) {
            query.operation = 'IN'
            query.value = filter
            this.querys.push(query)
          }
        })
      }
    },
    handleSizeChange(pageSize) {
      this.pagination = { ...this.pagination, pageSize }
      this.load()
    },
    handleCurrentChange(page) {
      this.pagination = { ...this.pagination, page }
      // 翻页时不重置页码
      this.load(true)
    },
    handleRowClick(row, column, event) {
      this.$emit('row-click', row, column, event)
    },
    handleTableSelect(selection, row) {
      this.selection = selection
      console.log(this.selection)
      if (row) {
        this.$emit('select', selection, row)
      } else {
        this.$emit('select-all', selection)
      }
    },
    handleSortChange(param) {
      if (!param.order) {
        this.sorter = null
      } else {
        if (param.column.sortBy !== undefined && param.column.sortBy.length > 0 && param.column.sortBy[0] !== undefined) {
          this.sorter = [
            {
              property: param.column.sortBy[0],
              direction: param.order == 'ascending' ? 'ASC' : 'DESC'
            }
          ]
        } else {
          this.sorter = [
            {
              property: param.prop,
              direction: param.order == 'ascending' ? 'ASC' : 'DESC'
            }
          ]
        }
      }
      this.load()
      this.$emit('sort-change', param)
    },
    handleFilterChange(m) {
      this.filters = { ...this.filters, ...m }
      Object.keys(this.filters).forEach((k) => {
        if (!this.filters[k] || this.filters[k].length == 0) {
          delete this.filters[k]
        }
      })
      this.load()
      this.$emit('filter-change', m)
    },
    // 初始化自定义列表项
    initialCustomColumn() {
      // 优先获取localStorage中的设置
      if (this.customColumnsHashCode) {
        this.currentCustomColumns = this.getLocalStorage(this.customColumnsHashCode)
      }
      // 没有localStorage时，根据表格列是否初始化隐藏来获取
      if (!this.currentCustomColumns) {
        let ccols = []
        this.customColumns.forEach((cs) => {
          cs.checked && ccols.push(cs.key)
        })
        this.currentCustomColumns = ccols.join(',')
      }
      this.applyCustomColumn()
    },
    // 将自定义列表项应用到当前表格、自定义列表项数组中
    applyCustomColumn() {
      const currentCustomColumnsAry = this.currentCustomColumns.split(',')
      // 同步选中状态到自定义列表数组中
      this.customColumns.forEach((cs) => {
        cs.checked = currentCustomColumnsAry.some((cca) => cca == cs.key)
      })
      // 同步选中状态到当前表格
      this.$slots.default.forEach((v) => {
        if (v && v.componentInstance && v.componentInstance.prop && v.componentInstance.label) {
          v.componentInstance.hiddenCol = !currentCustomColumnsAry.some((cca) => cca == v.componentInstance.prop)
        }
      })
      this.$nextTick(() => {
        this.$refs.ecoTable.doLayout()
      })
    },
    // 自定义列表项确定按钮
    customColumnDialogSure() {
      this.applyCustomColumn()
      // 同步选中状态到localStorage中
      if (this.customColumnsHashCode) {
        this.setLocalStorage(this.customColumnsHashCode, this.currentCustomColumns)
      }
      this.customColumnDialogVisible = false
    },
    // 自定义列表项取消按钮
    customColumnDialogCancel() {
      // 取消对话框时，可能用户已经勾选或去掉了一些选项，这里需要还原这些勾选操作
      let currentCustomColumnAry = []
      this.customColumns.forEach((cc) => {
        cc.checked && currentCustomColumnAry.push(cc.key)
      })
      this.currentCustomColumns = currentCustomColumnAry.join(',')
      this.customColumnDialogVisible = false
    },
    // 从localStorage中获取用于存放自定义列表项的对象
    getObjectFromLocalStorage() {
      if (localStorage) {
        let customColumnSetting = localStorage.getItem('customColumnSetting')
        if (!customColumnSetting) {
          customColumnSetting = '{}'
        }
        try {
          customColumnSetting = JSON.parse(customColumnSetting)
        } catch (e) {}
        if (!customColumnSetting || typeof customColumnSetting != 'object') {
          customColumnSetting = {}
        }
        return customColumnSetting
      }
      return null
    },
    setLocalStorage(key, value) {
      let customColumnSetting = this.getObjectFromLocalStorage()
      if (customColumnSetting) {
        customColumnSetting[key] = value
        localStorage.setItem('customColumnSetting', JSON.stringify(customColumnSetting))
      }
    },
    getLocalStorage(key) {
      let customColumnSetting = this.getObjectFromLocalStorage()
      if (customColumnSetting) {
        return customColumnSetting[key]
      }
      return null
    },
    calcTableHeight(delay) {
      // 动态计算表格的高度，自适应当前容器
      setTimeout(() => {
        if (!this.$refs.tablePanel) {
          return
        }
        const tablePanelHeight = this.$refs.tablePanel.$el.clientHeight
        const toolbarPanelHeight = this.$refs.toolbarPanel.clientHeight || 0
        const tabHeight = this.$refs.tabPanel.clientHeight || 0
        const tabHeight2 = this.$refs.tabPanel2.clientHeight || 0
        const paginationPanelHeight = (this.$refs.paginationPanel && this.$refs.paginationPanel.clientHeight) || 0
        const maxHeights = tablePanelHeight - 15 - tabHeight - tabHeight2 - toolbarPanelHeight - paginationPanelHeight
        if (typeof window !== 'undefined') {
          maxHeights <= 0 ? (this.tableMaxHeight =  window.document.body.clientHeight - 280) : (this.tableMaxHeight = maxHeights)
        }
        // this.tableMaxHeight =
        //   tablePanelHeight -
        //   5 -
        //   tabHeight -
        //   tabHeight2 -
        //   toolbarPanelHeight -
        //   paginationPanelHeight;
      }, delay || 0)
    },
    //点击导出按钮
    exports() {
      this.dialogExportVisible = true
    },
    //确定导出
    submitExport() {
      if (!this.exportData || this.exportData.expField.length < 1) {
        this.$message.info('请选择要导出的字段！')
        return
      }
      let expField = ''
      for (var i = 0; i < this.exportData.expField.length; i++) {
        if (i > 0) {
          expField += ','
        }
        expField += this.exportData.expField[i].name
      }
      expField = Base64.encode(expField)
      let data = {
        name: this.exportFilename,
        type: this.exportData.getType,
        expField: expField,
        displayField: this.exportDisplayFields,
        query: {
          querys: {},
          pageBean: {}
        }
      }
      if (this.exportQuerys) {
        this.exportQuerys.forEach((query) => {
          this.querys.push(query)
        })
      }
      data.query.querys = this.querys
      data.query.pageBean = this.pagination
      let loadingInstance = Loading.service({ fullscreen: true }) //开始
      this.$http.post(this.exportUrl, data, 'arraybuffer').then(
        (resp) => {
          loadingInstance.close() // 结束
          this.dialogExportVisible = false
        },
        (error) => {
          loadingInstance.close() // 结束
        }
      )
    },
    //取消导出
    exportCancel() {
      this.dialogExportVisible = false
      // this.exportData.expField = [];
    },
    //全选
    handleExportSelectAll() {
      this.exportData.expField = this.exportDisplayFields
    },
    handleExportSelectionChange(val) {
      this.exportData.expField = []
      if (val) {
        this.exportData.expField = val
      }
    },
    //排序
    sort(index, type) {
      if ('up' == type) {
        if (index === 0) {
          this.$message.warning('已经是列表中第一位')
        } else {
          let temp = this.exportDisplayFields[index - 1]
          this.$set(this.exportDisplayFields, index - 1, this.exportDisplayFields[index])
          this.$set(this.exportDisplayFields, index, temp)
        }
      } else {
        if (index === this.exportDisplayFields.length - 1) {
          this.$message.warning('已经是列表中最后一位')
        } else {
          this.isTransition = true
          let i = this.exportDisplayFields[index + 1]
          this.$set(this.exportDisplayFields, index + 1, this.exportDisplayFields[index])
          this.$set(this.exportDisplayFields, index, i)
        }
      }
    }
    //导出结束
  }
}
</script>
<style lang="stylus" scoped>
.searchBtn {
  cursor: pointer;
}

.eco-table-panel {
  padding: 0px;
  height: 100%;
  overflow: hidden;
}

.eco-table {
  width: 100%;
}

.search-container__col {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  flex-direction: row;
  align-items: center;
}

.toolbar-panel {
  margin-bottom: 15px;
}

.select-search-panel {
  margin-bottom: 5px;
}

.quick-search {
  max-width: 400px;
}

.quick-search + .el-divider {
  margin-right: 20px;
}

>>> .el-input__inner, >>> .el-input-group__append {
  border-radius: 0;
}

.common-tools > .el-link {
  float: right;
  margin-right: 15px;
}

.common-tools > .el-button {
  float: right;
  padding: 6px 3px;
  border-radius: 0;
}

.common-tools > .el-button + .el-button {
  margin-right: 5px;
}

.common-tools > .el-button >>> i {
  font-weight: bold;
  font-size: 16px;
}

>>> .eco-table .sort-caret.descending {
  bottom: 0px;
}

>>> .eco-table .sort-caret.ascending {
  top: -2px;
}

>>> .eco-table .caret-wrapper {
  height: 20px;
}

>>> .eco-table .el-table__column-filter-trigger {
  line-height: 20px;
}

.pagination-panel {
  padding: 5px 0;
}

.pagination-panel >>> .el-input__inner {
  height: 23px !important;
  line-height: 23px !important;
}

.popoverBtn {
  font-size: 24px;
  color: #DCDFE6;
  margin-bottom: 20px;
}

.popoverBtn:hover {
  color: #DCDFE6;
}

.advanceBtn {
  float: left;
  height: 32px;
  width: 80px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.advanceBtn2 {
  margin-left: 10px;
  float: left;
  border: 1px solid rgba(41, 124, 249, 100);
  height: 32px;
  background-color: rgba(255, 255, 255, 100);
  color: rgba(41, 124, 249, 100);
  padding: 0;
  width: 80px;
}

.bgWhite {
  background-color: #fff;
  border-bottom: 0;
  color: #409eff;
  position: relative;
  z-index: 20;
}

.bgWhite:hover {
  background-color: #fff;
  border: #DCDFE6 1px solid;
  border-bottom: 0;
  color: #409eff;
}

.bgWhite:visited {
  background-color: #fff;
  border: #DCDFE6 1px solid;
  border-bottom: 0;
  color: #409eff;
}

.bgWhite:active {
  background-color: #fff;
  border: #DCDFE6 1px solid;
  border-bottom: 0;
  color: #409eff;
}

.bgWhite:focus {
  background-color: #fff;
  border: #DCDFE6 1px solid;
  border-bottom: 0;
  color: #409eff;
}

.deleteBtnForTable, .addBtnForTable {
  width: 24px;
}

.exportBtn {
  font-size: 24px;
  color: rgba(33, 98, 248, 1);
  position: relative;
  top: -3px;
}
</style>
<style lang="scss">
#feTable {
  .advancedPopover {
    width: calc(100% - 500px);
    margin-top: -1px !important;
    min-height: 40%;
    box-shadow: 0 7px 12px 0 rgba(0, 0, 0, 0.1) !important;
    left: 200px !important;
  }
  .el-table__fixed-right-patch {
    background-color: #f3f3f3;
  }
  .el-table__fixed-left-patch {
    background-color: #f3f3f3;
  }
  .el-table .ascending .sort-caret.ascending {
    border-bottom-color: #fff;
  }
  .el-table .descending .sort-caret.descending {
    border-top-color: #fff;
  }
}
</style>
